import { render, staticRenderFns } from "./ChangeRequirementsSlidebar.vue?vue&type=template&id=444a5186"
import script from "./ChangeRequirementsSlidebar.vue?vue&type=script&lang=js"
export * from "./ChangeRequirementsSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports